import { IBroadcastCommand } from '@/interfaces';
import { photoViewer } from './photoViewer';
import { events } from './events';
import { modal } from './modal';
import { Subject } from 'rxjs';

const VARIABLES = {
  subject: new Subject<IBroadcastCommand>()
};

const broadcastService = {

  publish: <TPayload>(action: IBroadcastCommand<TPayload>) => VARIABLES.subject.next(action),

  observable: () => VARIABLES.subject.asObservable(),
  
  photoViewer,
  events,
  modal

};

export default broadcastService;
